import {
    Box,
    Button,
    Grid,
    GridItem,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
} from "@chakra-ui/react";
import {useEffect, useState} from "react";
import TextInput from "../formFields/TextInput.tsx";
import type {patientRecordType} from "../../utils/typesConstant/types";
import {useUpdatePatientRecordMutation} from "../../store/patientApi/patientApiSlice.ts";

interface EditSummaryModalProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    recordDetails?: patientRecordType;
    setRecordDetails?: (record: patientRecordType) => void;
}

export default function EditSummaryModal({
                                             open,
                                             setOpen,
                                             recordDetails,
                                             setRecordDetails,
                                         }: EditSummaryModalProps) {
    const [formData, setFormData] = useState<patientRecordType>({
        uid: "",
        record_data: "",
        diagnosis: "",
        medication: "",
        next_visit: "",
        last_visit: "",
        recovery_status: "",
        summary: "",
        prescribed_treatment: "",
        lifestyle_advise: "",
        dosage: "",
        discharge_condition: "",
        follow_up: "",
        record_id: "",
        patient_id: "",
    });

    const [updatePatientRecord] = useUpdatePatientRecordMutation();

    useEffect(() => {
        if (recordDetails) {
            setFormData(recordDetails);
        }
    }, [recordDetails]);

    const handleClose = () => {
        setFormData(recordDetails)
        setOpen(false);
    };

    const getMinDate = () => {
        const date = new Date();
        date.setDate(date.getDate() - 2); // 2 days ago
        return date.toISOString().split('T')[0]; // 'YYYY-MM-DD'
    };

    function formatDate(isoDateString) {
        const date = new Date(isoDateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();
        // return `${day}/${month}/${year}`;
        return `${year}-${month}-${day}`;
    }


    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const formDataEntries = new FormData(event.currentTarget);
        const formJson = Object.fromEntries((formDataEntries as any).entries());

        const updatedData: patientRecordType = {
            uid: formData.uid,
            record_id: formData.record_id,
            patient_id: formData.patient_id,
            record_data: formJson.record_data as string,
            diagnosis: formJson.diagnosis as string,
            medication: formJson.medication as string,
            next_visit: formJson.next_visit as string,
            last_visit: formJson.last_visit as string,
            recovery_status: formJson.recovery_status as string,
            summary: formJson.summary as string,
            prescribed_treatment: formJson.prescribed_treatment as string,
            lifestyle_advise: formJson.lifestyle_advise as string,
            dosage: formJson.dosage as string,
            discharge_condition: formJson.discharge_condition as string,
            follow_up: formJson.follow_up as string,
        };

        // Prevent update if no changes were made
        if (recordDetails && JSON.stringify(updatedData) === JSON.stringify(recordDetails)) {
            console.log("No changes detected.");
            handleClose();
            return;
        }

        console.log("Updating record with:", updatedData);
        await updatePatientRecord(updatedData);

        // setRecordDetails?.({} as patientRecordType);
        setRecordDetails?.(updatedData);
        handleClose();
    };

    return (
        <Modal isOpen={open} onClose={handleClose} size="5xl">
            <ModalOverlay/>
            <ModalContent as="form" onSubmit={handleSubmit}>
                <ModalHeader>Edit Patient Summary</ModalHeader>
                <ModalCloseButton/>
                <ModalBody>
                    <Box>
                        <Grid templateColumns="repeat(12, 1fr)" gap={4} mb={4}>
                            <GridItem colSpan={12}>
                                {/*<TextInput*/}
                                {/*    id="summary"*/}
                                {/*    label="Summary"*/}
                                {/*    name="summary"*/}
                                {/*    value={formData.summary}*/}
                                {/*    formObject={formData}*/}
                                {/*    setFormObject={setFormData}*/}
                                {/*/>*/}
                                <TextInput
                                    id="summary"
                                    label="Summary"
                                    name="summary"
                                    value={formData.summary}
                                    formObject={formData}
                                    setFormObject={setFormData}
                                    isTextarea={true}
                                    inputProps={{rows: 3}}
                                />

                            </GridItem>
                            <GridItem colSpan={6}>
                                <TextInput
                                    id="diagnosis"
                                    label="Diagnosis"
                                    name="diagnosis"
                                    value={formData.diagnosis}
                                    formObject={formData}
                                    setFormObject={setFormData}
                                    isTextarea={true}
                                    inputProps={{rows: 3}}
                                />
                            </GridItem>
                            <GridItem colSpan={6}>
                                <TextInput
                                    id="medication"
                                    label="Medication"
                                    name="medication"
                                    value={formData.medication}
                                    formObject={formData}
                                    setFormObject={setFormData}
                                    isTextarea={true}
                                    inputProps={{rows: 3}}
                                />
                            </GridItem>
                            <GridItem colSpan={6}>
                                <TextInput
                                    id="dosage"
                                    label="Dosage"
                                    name="dosage"
                                    value={formData.dosage}
                                    formObject={formData}
                                    setFormObject={setFormData}
                                />
                            </GridItem>
                            <GridItem colSpan={6}>
                                <TextInput
                                    id="prescribed_treatment"
                                    label="Prescribed Treatment"
                                    name="prescribed_treatment"
                                    value={formData.prescribed_treatment}
                                    formObject={formData}
                                    setFormObject={setFormData}
                                />
                            </GridItem>
                            {/*<GridItem colSpan={6}>*/}
                            {/*    <TextInput*/}
                            {/*        id="lifestyle_advise"*/}
                            {/*        label="Lifestyle Advice"*/}
                            {/*        name="lifestyle_advise"*/}
                            {/*        value={formData.lifestyle_advise}*/}
                            {/*        formObject={formData}*/}
                            {/*        setFormObject={setFormData}*/}
                            {/*    />*/}
                            {/*</GridItem>*/}
                            <GridItem colSpan={6}>
                                <TextInput
                                    id="recovery_status"
                                    label="Recovery Status"
                                    name="recovery_status"
                                    value={formData.recovery_status}
                                    formObject={formData}
                                    setFormObject={setFormData}
                                />
                            </GridItem>
                            <GridItem colSpan={6}>
                                <TextInput
                                    id="discharge_condition"
                                    label="Discharge Condition"
                                    name="discharge_condition"
                                    value={formData.discharge_condition}
                                    formObject={formData}
                                    setFormObject={setFormData}
                                />
                            </GridItem>
                            <GridItem colSpan={6}>
                                <TextInput
                                    id="follow_up"
                                    label="Follow Up"
                                    name="follow_up"
                                    value={formData.follow_up}
                                    formObject={formData}
                                    setFormObject={setFormData}
                                />
                            </GridItem>
                            <GridItem colSpan={6}>
                                <TextInput
                                    id="next_visit"
                                    label="Next Visit"
                                    name="next_visit"
                                    type='date'
                                    min={getMinDate()}
                                    value={formatDate(formData.next_visit)}
                                    formObject={formData}
                                    setFormObject={setFormData}
                                />
                            </GridItem>
                            <GridItem colSpan={6}>
                                <TextInput
                                    id="last_visit"
                                    label="Last Visit"
                                    name="last_visit"
                                    type='date'
                                    min={getMinDate()}
                                    value={formatDate(formData.last_visit)}
                                    formObject={formData}
                                    setFormObject={setFormData}
                                />
                            </GridItem>
                        </Grid>
                    </Box>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={handleClose} mr={3}>
                        Cancel
                    </Button>
                    <Button type="submit" colorScheme="blue">
                        Save
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
